/**
 * Section registry for the editable marketing page system.
 *
 * Maps section type strings (as stored in layout JSON) to their React components.
 * This file is also imported by the admin builder for live preview — it intentionally
 * has NO side effects; it is a clean type → component map only.
 *
 * LEGACY types (join-us-as-library page): hero, socialProof, pricing, problems,
 *   benefits, features, howItWorks, websiteAddon, priceTiers, featuredLibraries,
 *   faq, signup, scrollProgressBar, marketingHeader, marketingFooter
 *
 * GENERIC types (new blank pages): genericHero, genericContent, genericMedia,
 *   genericItems, genericCta, libraries, spacer
 */

import ScrollProgressBar from '../components/ScrollProgressBar';
import MarketingHeader from '../sections/MarketingHeader';
import HeroSection from '../sections/HeroSection';
import SocialProofStrip from '../sections/SocialProofStrip';
import PricingSection from '../sections/PricingSection';
import ProblemsSection from '../sections/ProblemsSection';
import BenefitsSection from '../sections/BenefitsSection';
import FeaturesSection from '../sections/FeaturesSection';
import HowItWorksSection from '../sections/HowItWorksSection';
import WebsiteAddonSection from '../sections/WebsiteAddonSection';
import PriceTiersSection from '../sections/PriceTiersSection';
import FeaturedLibrariesSection from '../sections/FeaturedLibrariesSection';
import FaqSection from '../sections/FaqSection';
import SignupSection from '../sections/SignupSection';
import MarketingFooter from '../sections/MarketingFooter';

// Generic section types (no prefill, content-agnostic)
import GenericHeroSection from '../sections/generic/GenericHeroSection';
import GenericContentSection from '../sections/generic/GenericContentSection';
import GenericMediaSection from '../sections/generic/GenericMediaSection';
import GenericItemsSection from '../sections/generic/GenericItemsSection';
import GenericCtaSection from '../sections/generic/GenericCtaSection';
import LibrariesSection from '../sections/generic/LibrariesSection';
import SpacerSection from '../sections/generic/SpacerSection';

const sectionRegistry = {
  // ── Legacy types (keep untouched) ───────────────────────────────────────────
  scrollProgressBar: ScrollProgressBar,
  marketingHeader: MarketingHeader,
  hero: HeroSection,
  socialProof: SocialProofStrip,
  pricing: PricingSection,
  problems: ProblemsSection,
  benefits: BenefitsSection,
  features: FeaturesSection,
  howItWorks: HowItWorksSection,
  websiteAddon: WebsiteAddonSection,
  priceTiers: PriceTiersSection,
  featuredLibraries: FeaturedLibrariesSection,
  faq: FaqSection,
  signup: SignupSection,
  marketingFooter: MarketingFooter,

  // ── Generic types (new blank pages) ─────────────────────────────────────────
  genericHero: GenericHeroSection,
  genericContent: GenericContentSection,
  genericMedia: GenericMediaSection,
  genericItems: GenericItemsSection,
  genericCta: GenericCtaSection,
  libraries: LibrariesSection,
  spacer: SpacerSection,
};

export default sectionRegistry;
